import request from "../../untils/request.js"

/**
 *
 *  post
 *
 */
export const getFinancialDetailsPage = (params) => {
    return request.get("/outpatient/funddetail/page", {params} )
}

export const getFinancialDetailsStatistics = (params) => {
    return request.get("/outpatient/funddetail/statis", {params} )
}

export default{

}